// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';
export const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || 'http://localhost:8000/uploads';
export const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:3000';

// Contact Information
export const CONTACT_INFO = {
  email: import.meta.env.VITE_CONTACT_EMAIL || 'bukawaace@gmail.com',
  phone1: import.meta.env.VITE_CONTACT_PHONE_1 || '+256786142168',
  phone2: import.meta.env.VITE_CONTACT_PHONE_2 || '+256703969575',
  address: import.meta.env.VITE_CONTACT_ADDRESS || 'P.O Box 358 Iganga, Uganda',
  location: 'Nakisenyi Village, Wairama Parish, Nakigo Sub-County, Kigulu South, Iganga District',
  coordinates: {
    lat: 0.6089, // Approximate coordinates for Iganga District
    lng: 33.4689
  }
};

// Social Media Links
export const SOCIAL_LINKS = {
  facebook: import.meta.env.VITE_FACEBOOK_URL || '#',
  twitter: import.meta.env.VITE_TWITTER_URL || '#',
  instagram: import.meta.env.VITE_INSTAGRAM_URL || '#',
  linkedin: import.meta.env.VITE_LINKEDIN_URL || '#',
};

// Company Information
export const COMPANY_INFO = {
  name: 'Bukawa Area Marketing Enterprise Cooperative Society Ltd',
  shortName: 'Bukawa ACE Ltd',
  tagline: 'Leading in Quality',
  registrationNumber: '6952',
  registrationDate: 'January 16, 2004',
  yearEstablished: 2003,
  totalMembers: 1052,
  totalCooperatives: 10,
};

// Mission, Vision, Values
export const MISSION = 'To increase household income through commercial production, post-harvest handling, bulking, and disseminate market information, value addition and collective marketing.';

export const VISION = 'To be the preferred choice of maize producers in the region for maize products marketing and for purchasing inputs and value addition.';

export const VALUES = [
  { id: 1, name: 'Integrity', icon: 'shield' },
  { id: 2, name: 'Transparency', icon: 'eye' },
  { id: 3, name: 'Accountability', icon: 'checkCircle' },
  { id: 4, name: 'Honesty', icon: 'heart' },
];

// Member Cooperatives
export const MEMBER_COOPERATIVES = [
  { id: 1, name: 'Nakigo Growers Cooperative Society Ltd', type: 'Primary Cooperative' },
  { id: 2, name: 'Wairama Growers Cooperative Society Ltd', type: 'Primary Cooperative' },
  { id: 3, name: 'Kabiira Growers Cooperative Society Ltd', type: 'Primary Cooperative' },
  { id: 4, name: 'Bubinga Youth Group', type: 'Youth Group' },
  { id: 5, name: 'Nakisenyi United Farmers Association', type: 'Farmers Association' },
  { id: 6, name: 'Twekembe Youth Group', type: 'Youth Group' },
  { id: 7, name: 'Alininkira Rural Producer Organization', type: 'Rural Producer Org' },
  { id: 8, name: 'Kikola Ayenda Rural Producer Organization', type: 'Rural Producer Org' },
  { id: 9, name: 'Tugezeku Rural Producer Organization', type: 'Rural Producer Org' },
  { id: 10, name: 'Balindakulya Growers Cooperative Society Ltd', type: 'Primary Cooperative' },
];

// Partners
export const PARTNERS = [
  {
    id: 1,
    name: 'United States African Development Foundation (USADF)',
    contribution: '906 million UGX',
    project: 'Maize processing and marketing (Project Number UGA-5423)',
    status: 'Terminated',
  },
  {
    id: 2,
    name: 'Agriculture Cluster Development - MAAIF',
    contribution: '281 million UGX',
    project: 'Post-harvest handling processing and marketing',
    period: 'September 2020 - September 2022',
    status: 'Completed',
  },
  {
    id: 3,
    name: 'Stanbic Bank',
    contribution: '37 million UGX',
    project: 'Crop Finance',
    status: 'Active',
  },
  {
    id: 4,
    name: 'Uganda Development Trust',
    contribution: 'Technical skills support',
    project: 'Capacity building',
    status: 'Active',
  },
  {
    id: 5,
    name: 'Uganda Development Bank Ltd',
    contribution: 'Asset financing',
    project: '1 truck and 1 tractor',
    status: 'Active',
  },
];

// Products
export const PRODUCTS = [
  {
    id: 1,
    name: 'Premium White Maize Flour',
    description: 'High-quality, 100% pure white maize flour milled from locally sourced maize',
    features: ['Consistency', 'Traceability', 'Ethical Sourcing'],
    certifications: ['UNBS', 'GMP'],
    packaging: ['50kg bags'],
    price: null, // Contact for pricing
    image: '/whitemaizeflour.png',
    nutritionFacts: {
      servingSize: '22g (ngiji)',
      servingsPerPackage: 500,
      calories: 365,
      protein: '18%',
      fat: '36.6g',
      carbohydrates: '77g',
      fiber: '29%',
      vitamins: {
        a: '79.9mg (14%)',
        b1: '0.2mg (1µas) (33%)',
        b8: '8.9 (Ceaser Ourd) (35%)',
        b6: '0.33mg (gace) (24%)',
      },
      minerals: {
        calcium: '10mg (11%)',
        iron: '15%',
        semicy: '20%',
        vominss: '20µg (20%)',
        somics: '14%',
      }
    }
  },
];

// Services
export const SERVICES = [
  {
    id: 1,
    title: 'Bulking & Marketing',
    description: 'Collective bulking and marketing of agricultural products from member farmers',
    icon: 'package',
  },
  {
    id: 2,
    title: 'Value Addition',
    description: 'Processing and value addition services including maize milling',
    icon: 'gear',
  },
  {
    id: 3,
    title: 'Market Information',
    description: 'Gathering, analyzing and disseminating market information to members',
    icon: 'chart',
  },
  {
    id: 4,
    title: 'Input Supply',
    description: 'Collective purchasing of agricultural requirements for members',
    icon: 'truck',
  },
  {
    id: 5,
    title: 'Agricultural Extension',
    description: 'Expert advice and improved methods of agriculture',
    icon: 'users',
  },
  {
    id: 6,
    title: 'Post-Harvest Handling',
    description: 'Professional post-harvest handling and storage services',
    icon: 'warehouse',
  },
];

// Navigation Links
export const NAV_LINKS = [
  { id: 1, name: 'Home', path: '/' },
  { id: 2, name: 'About Us', path: '/about' },
  { id: 3, name: 'Products', path: '/products' },
  { id: 4, name: 'Services', path: '/services' },
  { id: 5, name: 'Membership', path: '/membership' },
  { id: 6, name: 'Gallery', path: '/gallery' },
  { id: 7, name: 'Contact', path: '/contact' },
];

// Stats for homepage
export const STATS = [
  { id: 1, label: 'Individual Members', value: '1,052+', icon: 'users' },
  { id: 2, label: 'Member Cooperatives', value: '10', icon: 'building' },
  { id: 3, label: 'Years of Service', value: '21+', icon: 'calendar' },
  { id: 4, label: 'Districts Reached', value: 'Multiple', icon: 'mapPin' },
];

// FAQ Data
export const FAQ_DATA = [
  {
    id: 1,
    question: 'What is Bukawa ACE Ltd?',
    answer: 'Bukawa Area Marketing Enterprise Cooperative Society Ltd is a secondary cooperative organization registered in 2004, serving over 1,052 farmers and 10 primary cooperatives in Eastern Uganda.',
  },
  {
    id: 2,
    question: 'What products do you offer?',
    answer: 'We primarily offer Premium White Maize Flour, which is 100% pure, UNBS and GMP certified, and produced from ethically sourced maize from our member farmers.',
  },
  {
    id: 3,
    question: 'How can I become a member?',
    answer: 'You can apply for membership through our membership application form on this website or by visiting our offices in Nakisenyi Village, Iganga District.',
  },
  {
    id: 4,
    question: 'What services do you provide to members?',
    answer: 'We provide bulking and marketing services, value addition through processing, market information dissemination, collective input purchasing, agricultural extension services, and post-harvest handling.',
  },
  {
    id: 5,
    question: 'Where are you located?',
    answer: 'Our headquarters are located in Nakisenyi Village, Wairama Parish, Nakigo Sub-County, Kigulu South, Iganga District, Eastern Uganda.',
  },
  {
    id: 6,
    question: 'Do you offer bulk orders?',
    answer: 'Yes, we handle bulk orders for our Premium White Maize Flour. Please contact us for pricing and delivery arrangements.',
  },
];

// API Endpoints
export const API_ENDPOINTS = {
  products: '/products',
  productDetail: (id) => `/products/${id}`,
  contact: '/contact',
  membership: '/membership',
  news: '/news',
  newsDetail: (id) => `/news/${id}`,
  gallery: '/gallery',
  boardMembers: '/board-members',
  staffMembers: '/staff-members',
  cooperatives: '/cooperatives',
};

// Pagination
export const ITEMS_PER_PAGE = 12;
export const GALLERY_ITEMS_PER_PAGE = 16;

// Form Validation
export const VALIDATION_RULES = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^(\+256|0)[0-9]{9}$/,
  minNameLength: 2,
  maxNameLength: 100,
  minMessageLength: 10,
  maxMessageLength: 1000,
};

// Image Placeholder
export const IMAGE_PLACEHOLDER = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect fill="%23E8F5E9" width="400" height="300"/%3E%3Ctext fill="%232D5F2E" font-family="sans-serif" font-size="24" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EBukawa ACE%3C/text%3E%3C/svg%3E';

export default {
  API_BASE_URL,
  UPLOAD_URL,
  APP_URL,
  CONTACT_INFO,
  SOCIAL_LINKS,
  COMPANY_INFO,
  MISSION,
  VISION,
  VALUES,
  MEMBER_COOPERATIVES,
  PARTNERS,
  PRODUCTS,
  SERVICES,
  NAV_LINKS,
  STATS,
  FAQ_DATA,
  API_ENDPOINTS,
  ITEMS_PER_PAGE,
  VALIDATION_RULES,
  IMAGE_PLACEHOLDER,
};